import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Beranda from './pages/Beranda';
import Profil from './pages/Profil';
import ProgramStudi from './pages/ProgramStudi';
import Pendaftaran from './pages/Pendaftaran';
import Layanan from './pages/Layanan';
import Postingan from './pages/Postingan';
import PostinganDetail from './pages/PostinganDetail';
import ManajemenPostingan from './pages/ManajemenPostingan';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Beranda />} />
          <Route path="/profil" element={<Profil />} />
          <Route path="/program-studi" element={<ProgramStudi />} />
          <Route path="/pendaftaran" element={<Pendaftaran />} />
          <Route path="/layanan" element={<Layanan />} />
          <Route path="/postingan" element={<Postingan />} />
          <Route path="/postingan/:id" element={<PostinganDetail />} />
          <Route path="/admin/postingan" element={<ManajemenPostingan />} />
          {/* Halaman lainnya akan ditambahkan nanti */}
          <Route path="/program-studi/:id" element={<ComingSoon title="Detail Program Studi" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

// Placeholder component untuk halaman yang belum dibuat
const ComingSoon = ({ title }) => (
  <div style={{
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '100px',
    background: '#f5f9fc'
  }}>
    <h1 style={{ color: '#1a5f7a', marginBottom: '10px' }}>{title}</h1>
    <p style={{ color: '#666' }}>Halaman ini sedang dalam pengembangan</p>
  </div>
);

export default App;
